/* eslint no-param-reassign: ["error", { "props": false }] */
import normalize from '@/lib/normalize';

export default {
  startLoading(state) {
    state.loading = true;
  },
  parseResponseData(state, response) {
    const data = normalize(response);

    state.details = {
      calculatedImpedance: data.calculatedImpedance,
      distanceToFault: data.distanceToFault,
      comment: data.comment
    };

    state.loading = false;
  },
  setResponseError(state) {
    state.loading = false;
    state.error = 'Something went wrong';
  },
  updateState(state) {
    state.details = { ...state.details };
  }
};
